import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

let cachedRates = null;
let cacheExpiry = 0;
const CACHE_MS = 5 * 60 * 1000; // 5 min

export async function getRates() {
  if (cachedRates && Date.now() < cacheExpiry) {
    return cachedRates;
  }
  const { data } = await axios.get(`${BASE_URL}/api/rates`);
  cachedRates = { base: data.base, rates: data.rates || {} };
  cacheExpiry = Date.now() + CACHE_MS;
  return cachedRates;
}

/**
 * Convert amount from one currency to another using rates.
 * @param {number} amount - Amount in source currency (major units)
 * @param {string} from - Source currency (USD, EUR, GBP)
 * @param {string} to - Target currency
 * @param {object} rates - { USD: 1, EUR: 0.92, GBP: 0.79 } (from base USD)
 */
export function convert(amount, from, to, rates) {
  if (!rates || amount == null || from === to) return amount;
  const rFrom = rates[from];
  const rTo = rates[to];
  if (rFrom == null || rTo == null) return amount;
  return amount * (rTo / rFrom);
}
